import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import { useContext } from 'react';
function useZhCNLocale() {
  var configProviderProps = useContext(ConfigProvider.ConfigContext);
  var _configProviderProps$ = configProviderProps.locale,
    locale = _configProviderProps$ === void 0 ? zhCN : _configProviderProps$;
  return {
    locale: locale
  };
}
export default useZhCNLocale;